import React from 'react';
import { Linkedin, Twitter, Facebook, Share2 } from 'lucide-react';

export default function ShareButtons({ title, url, description }) {
  const encoded = {
    url: encodeURIComponent(url),
    title: encodeURIComponent(title),
    desc: encodeURIComponent(description || ''),
  };

  const links = [
    { label: 'LinkedIn', icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded.url}`, color: 'hover:text-[#0077B5]' },
    { label: 'X', icon: Twitter, href: `https://twitter.com/intent/tweet?url=${encoded.url}&text=${encoded.title}`, color: 'hover:text-black' },
    { label: 'Facebook', icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encoded.url}`, color: 'hover:text-[#1877F2]' },
    { label: 'WhatsApp', icon: Share2, href: `https://api.whatsapp.com/send?text=${encoded.title}%20${encoded.url}`, color: 'hover:text-[#25D366]' },
  ];

  return (
    <div className="flex items-center gap-3" data-testid="share-buttons">
      <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">Compartir</span>
      {links.map(l => (
        <a
          key={l.label}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          className={`w-9 h-9 flex items-center justify-center border border-slate-200 text-slate-500 transition ${l.color}`}
          title={`Compartir en ${l.label}`}
          data-testid={`share-${l.label.toLowerCase()}`}
        >
          <l.icon size={16} />
        </a>
      ))}
    </div>
  );
}
